import { getIconClassName } from '@uifabric/styling/lib/index';
import { observer } from 'mobx-react-lite';
import { AttachmentFullViewState } from 'owa-attachment-full-data';
import { AttachmentModel } from 'owa-attachment-model-store';
import { AttachmentThumbnailView } from 'owa-attachment-view';
import { ClientItemId } from 'owa-client-ids';
import { ControlIcons } from 'owa-control-icons';
import { isThumbnailableDocument } from 'owa-file';
import { FileIcon, getIconForFile } from 'owa-file-icon';
import * as React from 'react';
import AttachmentImageInfoView from './AttachmentImageInfoView';

export interface AttachmentImageProps {
    attachmentViewState: AttachmentFullViewState;
    attachment: AttachmentModel;
    onDeleteButtonClicked: (attachmentViewState: AttachmentFullViewState) => void;
    isActionsContainerVisible: boolean;
    parentItemId: ClientItemId;
    sxsId: string;
}

const classNames = require('classnames');
const styles = require('./AttachmentImageView.scss');

// This component is responsible for showing the attachment image view.
export default observer(function AttachmentImageView(props: AttachmentImageProps) {
    const attachmentName: string = props.attachment.model.Name;
    let fileIconClass: string = null;
    const fileIcon: FileIcon = getIconForFile(attachmentName);
    let placeholderCssClass: string = getIconClassName(ControlIcons.Photo2);
    const smallFileIcon: string = fileIcon.small;
    const largeFileIcon: string = fileIcon.large;

    if (isThumbnailableDocument(attachmentName)) {
        fileIconClass = smallFileIcon;
        placeholderCssClass = largeFileIcon;
    }

    return (
        <span tabIndex={-1}>
            <AttachmentThumbnailView
                attachmentViewState={props.attachmentViewState}
                placeHolderCSSClass={classNames(placeholderCssClass, styles.placeholder)}
                fileIconCssClass={fileIconClass}
                imageLoadErrorCSSClass={largeFileIcon}
                thumbnailWidth={160}
                thumbnailHeight={120}
            />
            <AttachmentImageInfoView
                attachment={props.attachment}
                attachmentViewState={props.attachmentViewState}
                onDeleteButtonClicked={props.onDeleteButtonClicked}
                isActionsContainerVisible={props.isActionsContainerVisible}
                parentItemId={props.parentItemId}
                sxsId={props.sxsId}
            />
        </span>
    );
});
